import { render, staticRenderFns } from "./withDrawalList.vue?vue&type=template&id=123b3edc&scoped=true&"
import script from "./withDrawalList.ts?vue&type=script&lang=js&"
export * from "./withDrawalList.ts?vue&type=script&lang=js&"
import style0 from "./withDrawalList.less?vue&type=style&index=0&id=123b3edc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123b3edc",
  null
  
)

export default component.exports